import PropTypes from "prop-types";
import Link from "next/link";
import Text from "components/shared/stays/Text";
import styles from "components/destination/BreadCrumb.module.scss";

export default function BreadCrumb({ links, currentDestination }) {
  return (
    <div className={styles.component}>
      <nav>
        <ul className={styles.list}>
          {links
            .slice(0)
            .reverse()
            .map((link) => (
              <li key={link.name} className={styles.item}>
                <Text size={2}>
                  <Link prefetch={false} href={`/destinations/${link.slug}`}>
                    {link.name}
                  </Link>
                  <span className={styles.divider}>/</span>
                </Text>
              </li>
            ))}
          {links.length > 0 && currentDestination && (
            <li className={styles.item}>
              <Text>{currentDestination}</Text>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
}

BreadCrumb.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      slug: PropTypes.string,
    })
  ),
  currentDestination: PropTypes.string,
};
